import { render, staticRenderFns } from "./xinxi.vue?vue&type=template&id=5e99e5c3&scoped=true&"
import script from "./xinxi.vue?vue&type=script&lang=js&"
export * from "./xinxi.vue?vue&type=script&lang=js&"
import style0 from "./xinxi.vue?vue&type=style&index=0&id=5e99e5c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99e5c3",
  null
  
)

export default component.exports